import { ID, IntlMessage } from "../Intl";

export function phone(value: string | null): IntlMessage | undefined {
  const regexp = new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{2}[\s.-]\d{2}$/);
  return value && !regexp.test(value) ? ID("valid.phone") : undefined;
}
